import React, { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";

import Flavor from "../assets/2024/startPage/SABOR-QUE-TE-ACERCA.png";
import FlavorEn from "../assets/2024/startPage/SABOR-QUE-TE-ACERCA-EN.png";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { BlueSection } from "../components/components/sharedSections/blueSection";
import { RedSection } from "../components/components/sharedSections/redSection";

import MainText from "../assets/2024/startOptions/TEXTO-SUPERIOR.png";
import MainTextEn from "../assets/2024/startOptions/TEXTO-SUPERIOR.png";

import Tarjeta from "../assets/2024/startOptions/TARJETA-ANVIDE„A-BOTON.png";
import Stickers from "../assets/2024/startOptions/STICKER-BOTON.png";
import Diviertete from "../assets/2024/startOptions/DIVIERTETE-Y-JUEGA-BOTON.png";

import Recetas from "../assets/2024/startOptions/BOTON-RECETAS.png";
import Novena from "../assets/2024/startOptions/NOVENA-DE-AGUINALDO-BOTON.png";
import Catalogo from "../assets/2024/startOptions/CATALOGO-BOTON.png";
export const StartOptions = () => {
  const path = useLocation().pathname;
  const donde = path.split("/")[1];
  const intl = useIntl();
  const [showModalRegister, setShowModalRegister] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="startPage">
      {/* <ModalLoginRegister show={showModalRegister} language={intl.locale} /> */}
      <Row className="startOptions__firstRow">
        <Row className="startOptions__container justify-content-center">
          <Col xs={12}>
            <img
              src={intl.locale.includes("es") ? Flavor : FlavorEn}
              className="startPage__flavor__image"
              alt="Letrero el sabor que te acerca"
            />
          </Col>
          <Col xs={12}>
            <img
              src={intl.locale.includes("es") ? MainText : MainTextEn}
              alt="Texto crea tus tarjetas"
              className="startOptions__text"
            />
          </Col>
          <Row className="justify-content-center">
            <Col xs={3}>
              <Link to={"card"}>
                <img
                  src={intl.locale.includes("es") ? Tarjeta : Tarjeta}
                  alt="Boton tarjetas"
                  className="w-100"
                />
              </Link>
            </Col>
            <Col xs={3}>
              <Link to={`/${donde}/stickers`}>
                <img
                  src={intl.locale.includes("es") ? Stickers : Stickers}
                  alt="Boton Stickers"
                  className="w-100"
                />
              </Link>
            </Col>
            <Col xs={3}>
              <Link to={`/${donde}/fun`}>
                <img
                  src={intl.locale.includes("es") ? Diviertete : Diviertete}
                  alt="Boton diviertete"
                  className="w-100"
                />
              </Link>
            </Col>
          </Row>
          <Row
            className="justify-content-center align-items-center mt-5"
            style={{ zIndex: "6", position: "relative" }}
          >
            <Col xs={3}>
              {" "}
              <Link to={`/${donde}/recipes`}>
                <img
                  src={intl.locale.includes("es") ? Recetas : Recetas}
                  alt="Boton Recetas"
                  className=" startOptions__imageButton"
                />
              </Link>
            </Col>
            <Col xs={3}>
              {" "}
              <img
                src={intl.locale.includes("es") ? Novena : Novena}
                alt="Boton Novena"
                className=" startOptions__imageButton"
              />
            </Col>
            <Col xs={3}>
              {" "}
              <img
                src={intl.locale.includes("es") ? Catalogo : Catalogo}
                alt="Boton Catalogo"
                className="startOptions__imageButton"
              />
            </Col>
          </Row>
        </Row>
      </Row>
      <BlueSection />
      <RedSection />
    </div>
  );
};
